import React from 'react';

const HighlightedText = ({ text, highlight }) => {
  if (!highlight || !text) {
    return text;
  }
  const regex = new RegExp(`(${highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);
  return parts.map((part, i) =>
    part.toLowerCase() === highlight.toLowerCase() ? (
      <mark key={i} style={{ backgroundColor: '#fff176', borderRadius: '2px', padding: 0 }}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};

export default HighlightedText;
